export const ECRITURE_COMPTABLE = {
  dateTransfere: 'Date de dernier transfert :',
  libelleEcriture: 'Libellé d\'écriture',
  date: 'Date',
  journal: 'Journal',
  etat: 'Etat',
  etatValide: 'Valide',
  etatNonValide: 'Non valide',
  lot: 'Lot',
  aucunLot: 'Aucun lot',
  transmisAu: 'Transmis au ',
  tabHeader: {
    libelle: 'Libellé',
    compte: 'Compte',
    debit: 'Débit',
    credit: 'Crédit',
    debut: 'Début',
    fin: 'Fin',
    compteAuxiliaire: 'Compte auxiliaire',
    compteAnalytique: 'Compte analytique',
    reference: 'Référence',
  },
  msgErreurTitre: 'Explication des erreurs',
};

export const VALIDATION_ECRITURE = {
  journalRequiered: 'Le code journal comptable est obligatoire',
  wordingRequiered: 'Le libellé de l\'écriture comptable est obligatoire',
  accWriLinCouTooLow: 'Pas assez de lignes pour que l\'écriture soit correcte',
  accWriLinCreCumZer: 'Le cumul des montants de crédit doit être différent de zéro. Vérifiez que le compte du tiers est bien saisi.',
  accWriLinWitNegCre: 'Aucun montant de crédit négatif n\'est autorisé',
  accWriLinImbAmo: 'Le cumul des montants des lignes d\'écritures est déséquilibré',
  accWriLinDebCumZer: 'Le cumul des montants de débit doit être différent de zéro. Vérifiez que le compte du tiers est bien saisi.',
  accWriLinWitNegDeb: 'Aucun montant de débit négatif n\'est autorisé',
  accWriLinReq: 'Les lignes d\'écriture comptable sont obligatoires',
  accWriLinLisNul: 'La liste des ligne d\'écriture comptable ne doit pas être nulle',
  minPosDatInv: 'La date min n\'est pas valide pour la date comptable',
  posDatReq: 'La date comptable est obligatoire',
  accWriNul: 'L\'écriture comptable ne peut pas être nulle',
  accWriRefReq: 'La référence de l\'écritiure comptable est obligatoire',
  comIdInv: 'Valeur de Guid invalide pour l\'ID de société',
  accWriLinAuxAccMis: 'Le compte auxiliaire de la ligne d\'écriture ne peut être rempli alors que le compte principal est vide',
  accWriLinAccNumReq: 'Le numéro de compte de la ligne d\'ecriture est obligatoire',
  accWriLinAccNumIsMissingFromSchemaComptable: 'Certains numéros de compte sont absents du schéma comptable {schemaComptable} pour la ligne d\'écriture.',
  accWriLinCreEquDeb: 'Les montants de débit et de crédit de la ligne d\'écriture ne peuvent pas être égaux',
  accWriLinWorReq: 'Le libellé de la ligne d\'écriture est obligatoire',
  accWriLinBegDatNulConParDeb: 'La date de début de période de la ligne d\'écriture comptable est obligatoire',
  accWriLinBegDatNulConParFin: 'La date de fin de période de la ligne d\'écriture comptable est obligatoire',
  accWriLinBegDatNotNullTieDeb: 'La date de début de période de la ligne d\'écriture {0} doit être vide',
  accWriLinBegDatNotNullTieFin: 'La date de fin de période de la ligne d\'écriture {0} doit être vide.',
  accWriLinBegDatNotNullTvaDeb: 'La date de début de période de la ligne d\'écriture {0} doit être vide',
  accWriLinBegDatNotNullTvaFin: 'La date de fin de période de la ligne d\'écriture {0} doit être vide',
  accWriLinNul: 'La ligne d\'écriture ne peut pas être nulle',
  accWriTypReq: 'Le type d\'écriture est obligatoire',
  accWriRefIdReq: 'L\'Id de la pièce de référence est obligatoire',
  cumulPasConforme: 'Le cumul des montants de l\'écriture n\'est pas conforme au montant TTC de la pièce d\'origine',
  ecriturePasRecente: 'L\'écriture comptable n\'est pas la plus récente.',
  exerciceAbsent: 'Aucun exercice comptable présent pour une écriture en date du {param1}',
  exerciceInactif: 'Exercice comptable inactif pour une écriture en date du {param1}',
  exerciceClos: 'Exercice comptable clos pour une écriture en date du {param1}',
};
